import { render } from "./todays-followup.vue?vue&type=template&id=224726dc&scoped=true"
import script from "./todays-followup.vue?vue&type=script&lang=js"
export * from "./todays-followup.vue?vue&type=script&lang=js"

import "./todays-followup.vue?vue&type=style&index=0&id=224726dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224726dc"]])

export default __exports__